export default "__VITE_ASSET__19fc7fd8__"